import _ from 'lodash'
import Vue from 'vue'
import reportGroupApi from '../../api/report-group'
import reportDataApi from '../../api/report-data'
import tempReportApi from '../../api/temp-report'

const state = {
  reportGroupData: {
    isEditMode: false,
    showGroupAddLayer: false
  },
  reportGroups: [],
  reportDataList: [],
  diagnosingId: null
}

const getters = {
  reportGroupData: state => state.reportGroupData,
  reportGroups: state => state.reportGroups.rows || state.reportGroups,
  reportDataList: state => state.reportDataList,
  diagnosingId: state => state.diagnosingId
}

const mutations = {
  setReportGroupEditMode (state, value) {
    state.reportGroupData.isEditMode = value
  },
  setShowReportGroupAddLayer (state, value) {
    state.reportGroupData.showGroupAddLayer = value
  },
  setReportGroups (state, value) {
    state.reportGroups = value
  },
  setReportDataList (state, value) {
    state.reportDataList = value
  },
  setDiagnosingId (state, value) {
    state.diagnosingId = value
  },
  deleteReportGroup (state, groupId) {
    const index = _.findIndex(state.reportGroups.rows || state.reportGroups, item => {
      return item.id === groupId
    })

    if (index !== -1) {
      (state.reportGroups.rows || state.reportGroups).splice(index, 1)
    }
  },
  deleteReportData (state, { groupId, reportDataId }) {
    const group = _.find(state.reportGroups.rows || state.reportGroups, item => {
      return item.id === groupId
    })

    if (group) {
      const index = _.findIndex(group.ReportData, item => {
        return item.id === reportDataId
      })

      if (index !== -1) {
        group.ReportData.splice(index, 1)
      }
    }
  }
}

const actions = {
  fetchDiagnosingId (context) {
    return tempReportApi.findProcessing().then(response => {
      const data = response.data
      context.commit('setDiagnosingId', data ? data.id : null)
      return data
    })
  },
  fetchReportGroups (context) {
    return reportGroupApi.findAll().then(response => {
      const data = response.data

      if (data) {
        _.forEach(data, item => {
          Vue.set(item, 'isEditMode', false)
        })
      }
      context.commit('setReportGroups', data)
      return data
    })
  },
  dashboardFetchReportList (context, option = {}) {
    if (!option.target) {
      option.target = null
    }
    if (!option.keyword) {
      option.keyword = null
    }
    if (!option.group) {
      option.group = null
    }

    reportDataApi.dashboardFindAll(option.page, option.target, option.keyword, option.group).then(response => {
      const data = response.data

      if (data.rows) {
        _.forEach(data.rows, reportData => {
          Vue.set(reportData, 'isEditMode', false)
          Vue.set(reportData, 'isDiagnosis', false)
        })
      }

      context.commit('setReportDataList', data)
      return data
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboard.js